<!--  -->
<template>
	<div class="app-container">
		<div class="oneCard">
			<div>
				<img src="../assets/xjj-logo.png" style="width: 50%" />
				<img src="../assets/logo.png" style="width: 50%" />
			</div>

		</div>


		<div class="threeCard">
			
	
					
			<div>
				<!-- 2.输入框 -->
				<div style="padding: 0 20px">
					<div class="inputCard">
						上分 下分 请登陆游戏后点击 在线客服 咨询处理。<br>您实际的用户名会自动加上lx2_
						</div>
					<div class="inputCard">
						<div style="margin: 0 30px">
							账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：
						</div>
						<input type="text" style="height: 25px; width: 20%" placeholder="请输入用户名，请使用字母或数字"
							v-model="account" />

					</div>
					<div class="inputCard">
						<div style="margin: 0 30px">
							密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码：
						</div>
						<input type="password" style="height: 25px; width: 20%" placeholder="请输入密码，须6-12位字母和数字"
							v-model="passwordOne" />

					</div>
				</div>
			</div>
			<div style="text-align: center; margin: 10px 30px;">
				<button class="submitBtn" style="border-radius: 5px;" @click="gotoLoginGame">确定登陆腾龙平台</button>
			</div>
		</div>

		<div class="foolCard">
			<!-- <img src="../assets/fnavleft.png" style="width: 100px; height: 100px;" /> -->
			<div style="color: #433920; padding: 0 200px">
				MYANMAR LICENSE CASINOS - GAMBLING BRAND LEADER, MORE HIGH-QUALITY
				GAMING PLATFORM, THE FIRST BRAND TO CREATE ONLINE GAMING , FRUIT BO
				EASTERN BURMA HAVE BOTH LEGALLY REGISTERED IN COSTA RICA LEGALLY
				REGISTERED GAMING COMPANIES .
			</div>

			<div style="margin: 20px 0">
				<span style="color: #433920">©版权所有2024</span>
				<span style="color: #f6e689">&nbsp;&nbsp;新锦江腾龙娱乐&nbsp;&nbsp;</span>
				<span style="color: #433920">Reserved</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		LoginGame
	} from "../network/apiFunc";
	import {
		encryptDES,
		MD5_JS
	} from "../util/secret.js";

	export default {
		data() {
			return {
				account: "",
				passwordOne: "",
				// 邀请码-上级代理编号
				invitationCode: "",
				// 固定的
				key: "zzi$i@@2",
				agentId: "1027773",
				md5key: "=74rdt#)",
				pcloginUrl: "https://www.itl246.com/pch5/",
				loginUrl: "https://www.itl246.com/h5/"
			};
		},

		methods: {
			gotoLoginGame() {
				var data =
					`{"account":"${this.account}","pwd":"${this.passwordOne}","actype":"1","dm":"${this.pcloginUrl}","md5key":"${this.md5key}"}`;
				var encryption = encryptDES(data, this.key);
				var md5Value = MD5_JS(encryption);
				if (this.account.length > 0) {
					if (this.passwordOne.length > 0) {
						LoginGame({
							sign: md5Value,
							data: encryption,
							agentId: 237944,
						}).then((res) => {
							console.log(res.data.errorCode);

							if (res.data.errorCode == 0) {
								alert("登陆成功！如果遇到打不开网页请多刷新尝试。");
									window.open(res.data.result.gameurl, '_blank','noreferrer');	
							} else {
								alert(res.data.errorMessage);
							}

						});
					} else {
						alert("密码不能为空");
					}
				} else {
					alert("用户名不能为空");
				}
			}
		},
		created() {
			// 获取当前页面的URL
			let url = window.location.href;
			// 解析URL，提取参数值
			let params = new URL(url).searchParams;
			this.account = params.get("account");
			this.passwordOne = params.get("passwordOne");

			// 输出pid的值
			console.log(this.account); // 在这个例子中，输出为 "888888"
			//this.invitationCode = pid;
			
		},
	};
</script>

<style scoped>
	.submitBtn {
		width: 30%;
		padding: 8px 0;
		background-color: #d19d58;
		border: none;
		/* font-weight: bold; */
		font-size: 18px;
	}

	.inputCard>input {
		border: 1px solid #c39c68;
		/* flex: 0 1 40%; */
		padding: 5px;
	}

	.inputCard {
		color: #c39c68;
		font-weight: bold;
		text-align: center;
		display: flex;
		justify-content: center;
		margin: 30px 0;
		display: flex;
		align-items: center;
	}

	.threeCard {
		background-image: url("../assets/web/headbg.jpg");
		background-repeat: no-repeat;
		background-repeat: no-repeat;
		background-size: cover;

		width: 100%;
		padding-bottom: 20px;
		overflow: hidden;

		color: #dda777;

		text-align: center;
	}

	.rechargePop {
		border: 1px solid tomato;
		position: fixed;
		z-index: 9999;
		top: 30%;
		background-color: tomato;
		left: 50%;
		width: 100%;
	}

	.rightCard {
		background-image: url("../assets/web/fix-rightbg.png");
		background-repeat: no-repeat;
		position: fixed;
		top: 100px;
		width: 10%;
		/* border: 1px solid gold; */
		z-index: 9999;
		right: 0;
		background-size: 100%;
		height: 600px;
		text-align: center;
	}

	.foolDown {
		margin: 0 20%;
		text-align: center;
		font-size: 15px;
		color: #666;
		font-weight: bold;
		margin: 10px 0;
	}

	.foolText:hover {
		color: #e5d485;
		cursor: pointer;
	}

	.foolText {
		border-top: 1px solid rgb(107, 107, 109);
		display: flex;
		justify-content: space-around;
		color: white;
		font-weight: bold;
		margin: 30px 20%;
		padding: 10px 0;
	}

	.honorCard>div {
		text-align: center;
	}

	.honorCard {
		/* border: 1px solid tomato; */
		margin: 0 20%;
		display: flex;
		justify-content: space-around;
		font-weight: bolder;
		font-size: 20px;
		color: #e5d485;
		align-items: center;
	}

	.foolCard {
		background-repeat: no-repeat;
		background-size: 100%;
		width: 100%;
		height: 100%;
		background-color: black;

		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.aboutCard {
		/* border: 1px solid black; */
		background-image: url("../assets/web/about_bg.jpg");
		background-repeat: no-repeat;
		background-size: 100%;
		height: 200px;
		margin: 0 20%;
		color: white;
		font-size: 12px;
		padding-left: 2%;
		padding-top: 100px;
	}

	.inPayType>div {
		display: flex;
		color: #e5d485;
		margin-top: 3%;
		cursor: pointer;
	}

	.inPayType {
		display: flex;
		justify-content: space-around;
		align-items: center;
		/* border: 1px solid goldenrod; */
		background-image: url("../assets/web/deposit_bg.png");
		height: 100px;
		background-repeat: no-repeat;
		margin: 0 20%;
		background-size: 100%;
	}

	.gameList:hover {
		cursor: pointer;
	}

	.gameList>div {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: white;
	}

	.gameList {
		display: flex;
		justify-content: space-evenly;
		margin: 6% 30%;
	}

	.menuRight {
		/* border: 1px solid tomato; */
		/* background-color: #c40304; */
		/* background-image: url("../assets/web/login02.png"); */
		width: 532px;
		height: 337px;
		background-repeat: no-repeat;
		color: #aa0000;
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
	}

	.activeMenu {
		text-align: center;
		margin: 10px 0;

		padding: 6px 10px;
	}

	.activeMenu:hover {
		cursor: pointer;
		border-radius: 12px;

		background: #cac531;
		/* fallback for old browsers */
		background: -webkit-linear-gradient(to right,
				#f3f9a7,
				#cac531);
		/* Chrome 10-25, Safari 5.1-6 */
		background: linear-gradient(to right,
				#f3f9a7,
				#cac531);
		/* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
	}

	.menuLeft {
		background-image: url("../assets/web/nav.png");
		background-size: contain;
		background-repeat: no-repeat;
	}

	.menuItem {
		color: white;
		margin: 2% 20%;
		display: flex;
		justify-content: space-between;
	}

	.twoCard {
		border: 1px solid rgb(51, 50, 50);
		/* background-image: url("../assets/web/07.jpg"); */
		height: auto;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.btnStyleOne {
		display: flex;
		justify-content: space-evenly;
		margin-top: 20px;
	}

	.BtnStyle {
		background-color: #c40304;
		border-radius: 6px;
		padding: 3px 10px;
	}

	.BtnStyle:hover {
		text-decoration: underline;
		cursor: pointer;
		color: blue;
	}

	.oneCardItem {
		/* border: 1px solid green; */
		text-align: center;
		width: 400px;
	}

	.oneCard {
		background-image: url("../assets/web/headbg.jpg");
		height: 100px;
		color: white;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 20%;

		/* border:1px solid tomato  */
	}

	.loginBtn {
		width: 80px;
		padding: 15px 0;
		background-color: #d19d58;
		border: none;
		font-weight: bold;
	}

	a {
		text-decoration: none;
		/* 去除下划线 */
		color: inherit;
		/* 使用继承的颜色 */
		padding: 10px 20px;
		font-size: 16px;
		background-color: #d19d58;
		color: black;
		text-decoration: none;
		border: none;
		border-radius: 5px;
		font-weight: bold;

		cursor: pointer;
		display: inline-block;
	}


	a:visited {
		color: black;
		/* 点击后保持白色 */
		font-weight: bold;

	}

	a:focus,
	a:active {
		outline: none;
		/* 去除点击后的虚线框 */
	}
</style>